import { Component, computed, inject, input, output, signal, TemplateRef, viewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocPreviewComponent, NgbModalService, SvgIconsComponent } from '@zayan-erp/shared';
import { merge } from 'rxjs';
import { ExternalDocument } from '../../../../models/deal-document.models';

@Component({
  selector: 'lib-external-signing',
  imports: [DocPreviewComponent, SvgIconsComponent],
  standalone: true,
  templateUrl: './external-signing.html',
  styleUrl: './external-signing.scss'
})
export class ExternalSigning {
  readonly #modalService = inject(NgbModal);
  readonly #ngbModalService = inject(NgbModalService);
  documentPreviewModal = viewChild<TemplateRef<unknown>>('documentPreviewModal');

  document = input<ExternalDocument | null>(null);
  documentCategory = input<string>('APS');

  replaceRequested = output<ExternalDocument | null>();

  selectedPreview = signal<{ name: string; url: string } | null>(null);

  documentInfo = computed(() => {
    const document = this.document();
    if (!document) {
      return null;
    }
    const normalized = document as ExternalDocument & {
      documentInfo?: { fileName?: string | null; directUrl?: string | null };
      doumentInfo?: { fileName?: string | null; directUrl?: string | null };
    };
    return normalized.documentInfo ?? normalized.doumentInfo ?? null;
  });

  documentUrl = computed(() => this.documentInfo()?.directUrl ?? '');

  openPreviewModal(): void {
    const url = this.documentUrl();
    if (!url) {
      return;
    }
    this.selectedPreview.set({ name: 'External Document', url });
    const modalRef = this.#modalService.open(this.documentPreviewModal(), this.#ngbModalService.fullscreenModal);
    merge(modalRef.closed, modalRef.dismissed).subscribe(() => this.selectedPreview.set(null));
  }

  onReplace(): void {
    this.replaceRequested.emit(this.document());
  }
}
